import React, { useState, useEffect } from "react";

import { Toaster, ListBoxModal } from "components";

import { func_validation } from "functions";

export function useUserGroupPermission(props) {
    const {
        userGroupList,
        seletedRowIdx,
        userGroupPermissionList,

        addPermission_requesting, removePermission_requesting,
        getUserGroupPermissionList_requesting,

        isUserRecordUpdatedSuccessfully
    } = props;

    // Validate props
    let userGroupPermissionList_validated = func_validation.isArrayNotEmpty(userGroupPermissionList)? userGroupPermissionList[0]?.UserGroupPermissionList:[];
    let userGroupPermissionLabels = [];
    userGroupPermissionList_validated.map((userGroupPermissionObj) => {
        let userGroupPermission = userGroupPermissionObj?.UserGroupPermission;
        if (userGroupPermission) {
            userGroupPermissionLabels.push(userGroupPermission);
        }
    });

    const [selectedUserGroupPermissionIndexList, setSelectedUserGroupPermissionIndexList] = useState();
    const [selectedUserGroupPermissionDetail, setSelectedUserGroupPermissionDetail] = useState({});
    const [isModalVisible_userGroupPermission, setIsModalVisible_userGroupPermission] = useState(false);

    function handleUserGroupPermissionUpdate(selectedValues) {
        // Username is required
        if (func_validation.isObjectEmpty(selectedUserGroupPermissionDetail)) return;
        let userGroupID = func_validation.getObjectPropertyValue(selectedUserGroupPermissionDetail, "ID");

        // convert to object for faster traversing
        let selectedValueObj = {}
        if (func_validation.isArrayNotEmpty(selectedValues)) {
            selectedValues.map((userDetails, idx) => {
                let userGroupPermission = func_validation.getObjectPropertyValue(userDetails, "UserGroupPermission");
                selectedValueObj[userGroupPermission] = true;
            })
        }
        let selectedUserGroupPermissionListObj = {};
        if (func_validation.isArrayNotEmpty(selectedUserGroupPermissionIndexList) &&
            func_validation.isArrayNotEmpty(userGroupPermissionList_validated)) {
            selectedUserGroupPermissionIndexList.map((UserGroupPermissionIdx, idx) => {
                let obj = userGroupPermissionList_validated[UserGroupPermissionIdx];
                let userGroupPermission = func_validation.getObjectPropertyValue(obj, "UserGroupPermission");
                selectedUserGroupPermissionListObj[userGroupPermission] = true;
            })
        }

        // Deletion
        let deletedList = [];
        if (func_validation.isArrayNotEmpty(selectedUserGroupPermissionIndexList)) {
            selectedUserGroupPermissionIndexList.map((userGroupPermissionIdx, index) => {
                let obj = userGroupPermissionList_validated[userGroupPermissionIdx];
                let userGroupPermission = func_validation.getObjectPropertyValue(obj, "UserGroupPermission");
                let permissionList = func_validation.getObjectPropertyValue(obj, "PermissionList");

                if (!selectedValueObj.hasOwnProperty(userGroupPermission) &&
                    func_validation.isArrayNotEmpty(permissionList)) {

                    // Add all permissions for that particular user group permission
                    permissionList.map((permissionObj) => {
                        let fullPermissionString = func_validation.getObjectPropertyValue(permissionObj, "Original");

                        // Get permission id
                        let groupPermissions = func_validation.getObjectPropertyValue(userGroupList[seletedRowIdx], "GroupPermissions");
                        if (func_validation.isArrayNotEmpty(groupPermissions)) {
                            for (let i = 0; i < groupPermissions.length; i++) {
                                let obj = groupPermissions[i];
                                let permissionName = func_validation.getObjectPropertyValue(obj, "PermissionName");
                                let permissionId = func_validation.getObjectPropertyValue(obj, "ID");

                                if (func_validation.isStringEqual_caseSensitive(permissionName, fullPermissionString)) {
                                    deletedList.push(permissionId);
                                    break;
                                }
                            }
                        }
                        
                    })
                }
            });

            if (props.removePermission &&
                func_validation.isArrayNotEmpty(deletedList)) {

                if (func_validation.isUserAccessGranted(props, "Internal_Permission_Delete")) {
                    props.removePermission(deletedList);
                }
                else {
                    Toaster({ 
                        type: "error",
                        msg: "No permission granted to remove user group permission"
                    });
                }
            }
        }

        // Addition
        let addedList = [];
        if (func_validation.isArrayNotEmpty(selectedValues)) {
            selectedValues.map((userGroupPermissionObj) => {
                let userGroupPermission = func_validation.getObjectPropertyValue(userGroupPermissionObj, "UserGroupPermission");
                let permissionList = func_validation.getObjectPropertyValue(userGroupPermissionObj, "PermissionList");

                if (!selectedUserGroupPermissionListObj.hasOwnProperty(userGroupPermission) &&
                    func_validation.isArrayNotEmpty(permissionList)) {

                    permissionList.map((permissionObj) => {
                        let fullPermissionString = func_validation.getObjectPropertyValue(permissionObj, "Original");

                        let obj = {};
                        obj["ID"] = 0;
                        obj["PermissionName"] = fullPermissionString;
                        obj["UserGroupId"] = userGroupID;
    
                        addedList.push(obj);                        
                    });
                }
            });

            if (props.addPermission &&
                func_validation.isArrayNotEmpty(addedList)) {

                if (func_validation.isUserAccessGranted(props, "Internal_Permission_Add")) {
                    props.addPermission(addedList);
                }
                else {
                    Toaster({ 
                        type: "error",
                        msg: "No permission granted to add user group permission"
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (props.getUserGroupPermissionList)
            props.getUserGroupPermissionList();
    }, [userGroupList]);

    let userGroupPermissionModal = (
        <ListBoxModal
            isModalVisible={isModalVisible_userGroupPermission}
            updateParentState={setIsModalVisible_userGroupPermission}

            title={"Group Permissions"}

            header={"List"}

            initSelectedIndexes={selectedUserGroupPermissionIndexList}
            list={userGroupPermissionList_validated}
            labelList={userGroupPermissionLabels}
            isListLoading={getUserGroupPermissionList_requesting}

            actionTxt={"Save"}
            handleOnConfirm={handleUserGroupPermissionUpdate}
            isActionLoading={addPermission_requesting || removePermission_requesting}
            isClosedOnSuccess={isUserRecordUpdatedSuccessfully}

            isDisabled={func_validation.isUserAccessDenied(props, "Internal_Permission_Add") &&
                func_validation.isUserAccessDenied(props, "Internal_Permission_Delete")}
        />
    );

    return {
        handleUserGroupPermissionUpdate,
        selectedUserGroupPermissionIndexList, setSelectedUserGroupPermissionIndexList,
        setSelectedUserGroupPermissionDetail,
        userGroupPermissionModal, setIsModalVisible_userGroupPermission,
        userGroupPermissionList_validated,
        userGroupPermissionLabels
    }
}